module.exports = __webpack_public_path__ + "static/img/leo.d3e7dc50.png";